import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import common from '../utils/Common';
import { Form, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import Table from './common/Table';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';

const AdminSummary = () => {
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(() => moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(() => moment().format('YYYY-MM-DD'));
  const [userDetails, setUserDetails] = useState([]);
  const [businessDetails, setBusinessDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [serviceDetails, setServiceDetails] = useState([]);
  const [logisticsDetails, setLogisticsDetails] = useState([]);
  const [productsDetails, setProductsDetails] = useState([]);
  const [servicesDetails, setServicesDetails] = useState([]);
  const [deliveryDetails, setDeliveryDetails] = useState([]);
  const [deactivatedDetails, setDeactivatedDetails] = useState([]);
  const [userModal, setUserModal] = useState(false);
  const [businessModal, setBusinessModal] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [serviceModal, setServiceModal] = useState(false);
  const [logisticsModal, setLogisticsModal] = useState(false);
  const [productsModal, setProductsModal] = useState(false);
  const [servicesModal, setServicesModal] = useState(false);
  const [deliveryModal, setDeliveryModal] = useState(false);
  const [deactivatedModal, setDeactivatedModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const userData = data.map((data, index) => ({
    "S.No": index + 1,
    "Total Users": data.total_users || 0,
    "Total Business Users": data.total_business_users || 0,
    "Total Product Sellers": data.total_product_sellers || 0,
    "Total Service Providers": data.total_service_providers || 0,
    "Total Logistics Providers": data.total_logistics_providers || 0,
    "Total Delivery Guys": data.total_delivery_guys || 0,
    "Total Products": data.total_products || 0,
    "Total Services": data.total_services || 0,
    "Start Date": startDate,
    "End Date": endDate,
    "Generated At": moment().format('YYYY-MM-DD HH:mm:ss')
  }));

  // Export Handlers
  const handleExportCSV = () => exportToCSV(userData, 'Admin Summary');
  const handleExportExcel = () => exportToExcel(userData, 'Admin Summary');
  const handleExportPDF = () => exportToPDF(userData, 'Admin Summary');
  const handleExportUserCSV = () => exportToCSV(userDetails, 'User Details');
  const handleExportUserExcel = () => exportToExcel(userDetails, 'User Details');
  const handleExportUserPDF = () => exportToPDF(userDetails, 'User Details');
  const handleExportBusinessCSV = () => exportToCSV(businessDetails, 'Business Details');
  const handleExportBusinessExcel = () => exportToExcel(businessDetails, 'Business Details');
  const handleExportBusinessPDF = () => exportToPDF(businessDetails, 'Business Details');
  const handleExportProductCSV = () => exportToCSV(productDetails, 'Product Details');
  const handleExportProductExcel = () => exportToExcel(productDetails, 'Product Details');
  const handleExportProductPDF = () => exportToPDF(productDetails, 'Product Details');
  const handleExportServiceCSV = () => exportToCSV(serviceDetails, 'Service Details');
  const handleExportServiceExcel = () => exportToExcel(serviceDetails, 'Service Details');
  const handleExportServicePDF = () => exportToPDF(serviceDetails, 'Service Details');
  const handleExportLogisticsCSV = () => exportToCSV(logisticsDetails, 'Logistics Details');
  const handleExportLogisticsExcel = () => exportToExcel(logisticsDetails, 'Logistics Details');
  const handleExportLogisticsPDF = () => exportToPDF(logisticsDetails, 'Logistics Details');
  const handleExportProductsCSV = () => exportToCSV(productsDetails, 'Products Details');
  const handleExportProductsExcel = () => exportToExcel(productsDetails, 'Products Details');
  const handleExportProductsPDF = () => exportToPDF(productsDetails, 'Products Details');
  const handleExportServicesCSV = () => exportToCSV(servicesDetails, 'Services Details');
  const handleExportServicesExcel = () => exportToExcel(servicesDetails, 'Services Details');
  const handleExportServicesPDF = () => exportToPDF(servicesDetails, 'Services Details');
  const handleExportDeliveryCSV = () => exportToCSV(deliveryDetails, 'Delivery Details');
  const handleExportDeliveryExcel = () => exportToExcel(deliveryDetails, 'Delivery Details');
  const handleExportDeliveryPDF = () => exportToPDF(deliveryDetails, 'Delivery Details');
  const handleExportDeactivatedCSV = () => exportToCSV(deactivatedDetails, 'Deactivated Details');
  const handleExportDeactivatedExcel = () => exportToExcel(deactivatedDetails, 'Deactivated Details');
  const handleExportDeactivatedPDF = () => exportToPDF(deactivatedDetails, 'Deactivated Details');

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  // Modal Toggles
  const toggleUserModal = () => {
    setUserModal(!userModal);
    if (userModal) setUserDetails([]);
  };
  const toggleBusinessModal = () => {
    setBusinessModal(!businessModal);
    if (businessModal) setBusinessDetails([]);
  };
  const toggleProductModal = () => {
    setProductModal(!productModal);
    if (productModal) setProductDetails([]);
  };
  const toggleServiceModal = () => {
    setServiceModal(!serviceModal);
    if (serviceModal) setServiceDetails([]);
  };
  const toggleLogisticsModal = () => {
    setLogisticsModal(!logisticsModal);
    if (logisticsModal) setLogisticsDetails([]);
  };
  const toggleProductsModal = () => {
    setProductsModal(!productsModal);
    if (productsModal) setProductsDetails([]);
  };
  const toggleServicesModal = () => {
    setServicesModal(!servicesModal);
    if (servicesModal) setServicesDetails([]);
  };
  const toggleDeliveryModal = () => {
    setDeliveryModal(!deliveryModal);
    if (deliveryModal) setDeliveryDetails([]);
  };
  const toggleDeactivatedModal = () => {
    setDeactivatedModal(!deactivatedModal);
    if (deactivatedModal) setDeactivatedDetails([]);
  };

  // Data Fetcher
  const fetchData = async () => {
    let data = {
      'start_date': startDate,
      'end_date': endDate,
    };
    let response = await common.apiRequest('post', '/admin/admin-summary', data);
    if (response.data.code === 'success') {
      setData(response.data.data);
    } else {
      setData([]);
    }
  };

  // Unified Details fetcher
  const getUserDetails = async (userIds, source, modalType = 'user') => {
    setLoading(true);
    try {
      let data = {
        'ids': userIds,
        'source': source
      };
      let response = await common.apiRequest('post', '/admin/user-details', data);
      if (response.status === 200) {
        if (response.data.code === 'success') {
          const responseData = response.data.data || [];
          switch(modalType) {
            case 'user':
              setUserDetails(responseData); setUserModal(true); break;
            case 'deactivated':
              setDeactivatedDetails(responseData); setDeactivatedModal(true); break;
            case 'business':
              setBusinessDetails(responseData); setBusinessModal(true); break;
            case 'product':
              setProductDetails(responseData); setProductModal(true); break;
            case 'service':
              setServiceDetails(responseData); setServiceModal(true); break;
            case 'logistics':
              setLogisticsDetails(responseData); setLogisticsModal(true); break;
            case 'products':
              setProductsDetails(responseData); setProductsModal(true); break;
            case 'services':
              setServicesDetails(responseData); setServicesModal(true); break;
            case 'delivery':
              setDeliveryDetails(responseData); setDeliveryModal(true); break;
            default:
              setUserDetails(responseData); setUserModal(true);
          }
        } else {
          alert(response.data.error);
        }
      } else {
        alert(response.data.error);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      alert('Error fetching user details');
    } finally {
      setLoading(false);
    }
  };

  // Handlers for date
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  // Table column definitions
  const columnDefs = [
    {
      header: "Total Users",
      accessor: "total_users",
      sortable: true,
      filter: true
    },
    {
      header: "Actions",
      accessor: "user_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.users_id, "user", "user")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View User Details"}
        </button>
      )
    },
    {
      header: "Total Deactivated Users",
      accessor: "total_deactivated_users",
      sortable: true,
      filter: true
    },
    {
      header: "Deactivated Details",
      accessor: "deactivated_user_details",
      render: row => (
        <button
        className="btn btn-primary btn-sm"
        onClick={() => getUserDetails(row.deactivated_users_id, "deactivated", "deactivated")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Deactivated Details"}
        </button>
      )
    },
    {
      header: "Total Business Users",
      accessor: "total_business_users",
      sortable: true,
      filter: true
    },
    {
      header: "Business Details",
      accessor: "business_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.business_users_id, "sellers", "business")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Business Details"}
        </button>
      )
    },
    {
      header: "Total Product Sellers",
      accessor: "total_product_sellers",
      sortable: true,
      filter: true
    },
    {
      header: "Product Details",
      accessor: "product_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.product_users_id, "sellers", "product")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Product Details"}
        </button>
      )
    },
    {
      header: "Total Service Providers",
      accessor: "total_service_providers",
      sortable: true,
      filter: true
    },
    {
      header: "Service Details",
      accessor: "service_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.service_users_id, "sellers", "service")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Service Details"}
        </button>
      )
    },
    {
      header: "Total Logistics Providers",
      accessor: "total_logistics_providers",
      sortable: true,
      filter: true
    },
    {
      header: "Logistics Details",
      accessor: "logistics_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.logistics_users_id, "sellers", "logistics")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Logistics Details"}
        </button>
      )
    },
    {
      header: "Total Delivery Guys",
      accessor: "total_delivery_guys",
      sortable: true,
      filter: true
    },
    {
      header: "Delivery Details",
      accessor: "delivery_details",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.delivery_users_id, "delivery", "delivery")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Delivery Details"}
        </button>
      )
    },
    {
      header: "Total Products",
      accessor: "total_products",
      sortable: true,
      filter: true
    },
    {
      header: "Product Details View",
      accessor: "product_details_view",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.product_id, "products", "products")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Products Details"}
        </button>
      )
    },
    {
      header: "Total Services",
      accessor: "total_services",
      sortable: true,
      filter: true
    },
    {
      header: "Service Details View",
      accessor: "service_details_view",
      render: row => (
        <button
          className="btn btn-primary btn-sm"
          onClick={() => getUserDetails(row.service_id, "services", "services")}
          disabled={loading}
        >
          {loading ? "Loading..." : "View Services Details"}
        </button>
      )
    }
  ];

  // Column defs for modals
  const userColumnDefs = [
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1 },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1 },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1 }
  ];
  const deactivatedColumnDefs = [
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1 },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1 },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1 }
  ];
  const businessColumnDefs = [
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1 },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1 },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1 },
    { header: "Business Name", accessor: "business_name", sortable: true, filter: true, flex: 1, render: row => row.user_business?.business_name || "" },
    { header: "Nature of Business", accessor: "nature_of_business", sortable: true, filter: true, flex: 1, render: row => row.user_business?.nature_of_business || "" }
  ];
  const productsColumnDefs = [
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1, render: row => row?.product?.user?.first_name || "" },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1, render: row => row?.product?.user?.last_name || "" },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1, render: row => row?.product?.user?.reg_id || "" },
    { header: "Business Name", accessor: "business_name", sortable: true, filter: true, flex: 1, render: row => row?.product?.user?.user_business?.business_name || "" },
    { header: "Nature of Business", accessor: "nature_of_business", sortable: true, filter: true, flex: 1, render: row => row?.product?.user?.user_business?.nature_of_business || "" },
    { header: "Product Name", accessor: "product_name", sortable: true, filter: true, flex: 1, render: row => row?.name || row?.product?.name || "" },
    { header: "Product SKU", accessor: "product_sku", sortable: true, filter: true, flex: 1, render: row => row?.product_sku || "" }
  ];
  const servicesColumnDefs = [
    { header: "S.No", accessor: "s_no", render: (_, index) => index + 1, width: 80, suppressSizeToFit: true },
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1, render: row => row?.user?.first_name || "" },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1, render: row => row?.user?.last_name || "" },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1, render: row => row?.user?.reg_id || "" },
    { header: "Business Name", accessor: "business_name", sortable: true, filter: true, flex: 1, render: row => row?.user?.user_business?.business_name || "" },
    { header: "Nature of Business", accessor: "nature_of_business", sortable: true, filter: true, flex: 1, render: row => row?.user?.user_business?.nature_of_business || "" },
    { header: "Service Name", accessor: "service_name", sortable: true, filter: true, flex: 1, render: row => row?.service_name || "" },
    { header: "Service SKU", accessor: "service_sku", sortable: true, filter: true, flex: 1, render: row => row?.service_sku || "" }
  ];
  const deliveryColumnDefs = [
    { header: "S.No", accessor: "s_no", render: (_, index) => index + 1, width: 80, suppressSizeToFit: true },
    { header: "First Name", accessor: "first_name", sortable: true, filter: true, flex: 1, render: row => row?.first_name || "" },
    { header: "Last Name", accessor: "last_name", sortable: true, filter: true, flex: 1, render: row => row?.last_name || "" },
    { header: "Reg Id", accessor: "reg_id", sortable: true, filter: true, flex: 1, render: row => row?.reg_id || "" },
    { header: "Business Name", accessor: "business_name", sortable: true, filter: true, flex: 1, render: row => row?.UserBusiness?.business_name || "" },
    { header: "Nature of Business", accessor: "nature_of_business", sortable: true, filter: true, flex: 1, render: row => row?.UserBusiness?.nature_of_business || "" },
    { header: "Business Owner Reg Id", accessor: "business_owner_reg_id", sortable: true, filter: true, flex: 1, render: row => row?.UserBusiness?.business_owner_reg_id || "" }
  ];

  // JSX
  return (
    <>
      <div className="col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Admin Summary</h4>
            <div className="d-flex gap-2">
              <button className='btn btn-sm btn-outline-primary' onClick={handleExportCSV}>
                Export to CSV
              </button>
              <button className='btn btn-sm btn-outline-success' onClick={handleExportExcel}>
                Export to Excel
              </button>
              <button className='btn btn-sm btn-outline-danger' onClick={handleExportPDF}>
                Export to PDF
              </button>
            </div>
          </div>
        </div>
        <Form className='row ml-4'>
          <FormGroup className='col-md-4 row'>
            <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
            <input
              type='date'
              value={startDate}
              onChange={handleStartDateChange}
              className="form-control col-md-5"
              id="Date-from"
              name="Date-from"
            />
          </FormGroup>
          <FormGroup className='col-md-4 row'>
            <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
            <input
              type='date'
              value={endDate}
              onChange={handleEndDateChange}
              className="form-control col-md-5"
              id="Date-to"
              name="Date-to"
            />
          </FormGroup>
        </Form>
        <div className="ag-theme-alpine" style={{ height: 600, width: '100%' }}>
          <Table
            data={data}
            columns={columnDefs}
          />
        </div>

        {/* User Details Modal */}
        <Modal isOpen={userModal} toggle={toggleUserModal} size="lg">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportUserCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportUserExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportUserPDF}>Export PDF</button>
          <ModalHeader toggle={toggleUserModal}>
            User Details ({userDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {userDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={userDetails}
                  columns={userColumnDefs}
                />
              </div>
            ) : (
              <div>No user details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Deactivated Details Modal */}
        <Modal isOpen={deactivatedModal} toggle={toggleDeactivatedModal} size="lg">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportDeactivatedCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportDeactivatedExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportDeactivatedPDF}>Export PDF</button>
          <ModalHeader toggle={toggleDeactivatedModal}>
            Deactivated Details ({deactivatedDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {deactivatedDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={deactivatedDetails}
                  columns={deactivatedColumnDefs}
                />
              </div>
            ) : (
              <div>No deactivated user details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Business Details Modal */}
        <Modal isOpen={businessModal} toggle={toggleBusinessModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportBusinessCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportBusinessExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportBusinessPDF}>Export PDF</button>
          <ModalHeader toggle={toggleBusinessModal}>
            Business Details ({businessDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {businessDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={businessDetails}
                  columns={businessColumnDefs}
                />
              </div>
            ) : (
              <div>No business details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Product Details Modal */}
        <Modal isOpen={productModal} toggle={toggleProductModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportProductCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportProductExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportProductPDF}>Export PDF</button>
          <ModalHeader toggle={toggleProductModal}>
            Product Details ({productDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {productDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={productDetails}
                  columns={businessColumnDefs}
                />
              </div>
            ) : (
              <div>No product details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Service Details Modal */}
        <Modal isOpen={serviceModal} toggle={toggleServiceModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportServiceCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportServiceExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportServicePDF}>Export PDF</button>
          <ModalHeader toggle={toggleServiceModal}>
            Service Details ({serviceDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {serviceDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={serviceDetails}
                  columns={businessColumnDefs}
                />
              </div>
            ) : (
              <div>No service details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Logistics Details Modal */}
        <Modal isOpen={logisticsModal} toggle={toggleLogisticsModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportLogisticsCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportLogisticsExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportLogisticsPDF}>Export PDF</button>
          <ModalHeader toggle={toggleLogisticsModal}>
            Logistics Details ({logisticsDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {logisticsDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={logisticsDetails}
                  columns={businessColumnDefs}
                />
              </div>
            ) : (
              <div>No logistics details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Products Details Modal */}
        <Modal isOpen={productsModal} toggle={toggleProductsModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportProductsCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportProductsExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportProductsPDF}>Export PDF</button>
          <ModalHeader toggle={toggleProductsModal}>
            Products Details ({productsDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {productsDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={productsDetails}
                  columns={productsColumnDefs}
                />
              </div>
            ) : (
              <div>No products details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Services Details Modal */}
        <Modal isOpen={servicesModal} toggle={toggleServicesModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportServicesCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportServicesExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportServicesPDF}>Export PDF</button>
          <ModalHeader toggle={toggleServicesModal}>
            Services Details ({servicesDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {servicesDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={servicesDetails}
                  columns={servicesColumnDefs}
                />
              </div>
            ) : (
              <div>No services details available</div>
            )}
          </ModalBody>
        </Modal>

        {/* Delivery Details Modal */}
        <Modal isOpen={deliveryModal} toggle={toggleDeliveryModal} size="xl">
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportDeliveryCSV}>Export CSV</button>
          <button className='btn btn-secondary btn-sm me-2' onClick={handleExportDeliveryExcel}>Export Excel</button>
          <button className='btn btn-secondary btn-sm' onClick={handleExportDeliveryPDF}>Export PDF</button>
          <ModalHeader toggle={toggleDeliveryModal}>
            Delivery Details ({deliveryDetails.length} records)
          </ModalHeader>
          <ModalBody>
            {deliveryDetails.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={deliveryDetails}
                  columns={deliveryColumnDefs}
                />
              </div>
            ) : (
              <div>No delivery details available</div>
            )}
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default AdminSummary;
